export enum ModelTypeEnum {
  Store = 'Store',
  Malloy = 'Malloy'
}
